import React, { useEffect, useState } from 'react'
import { Box, Button, Grid, MenuItem, Paper, } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { FilterComponent, PageLoader, PopOverCTA, STableLoader } from '../../../shared_elements';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import CashFlowListing from '../components/CashFlowListing';
import CashflowDetailsModal from '../components/CashflowDetailsModal';
import { ButtonLoader } from '../../../shared_elements/components';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useParams } from 'react-router';
import { RoleBaseAccess } from '../../../hoc';
import { isMobile } from 'react-device-detect';
import { trackActivity } from '../../../utils/mixpanel';
import { getCurrencyAc, getLesseeAc, getLessorAc, getOwnerListApi } from '../../../shared_elements/actionCreators';
import { getAssetListApi } from '../../leases/apiServices';
import { getCashflowCategoriesApi, getTransactionTypesApi } from '../../settings/cashflow_categories/apiService';
import ExportFileTypeComp from '../../../shared_elements/components/ExportFileTypeComp';
import { exportCashFlowApi } from '../apiService';
import { enqueueSnackbar } from 'notistack';
import moment from 'moment';
import DeploymentBannerWithOffset from '../../../shared_elements/components/DeploymentBannerWithOffSet';

const FleetCashflow = () => {
	const params=useParams();
	const dispatch = useDispatch();
	const [isLoading, setLoading] = useState(false)
	const { leaseBasicDetails } = useSelector((state) => state.leases);
	const [cashFlowListing, setCashFlowListing] = useState({})
	const [cashflowDetailsModal, setCashflowDetailsModal] = useState({
		open: false,
		start_date: null,
		end_date: null,
		mode: "monthly",
	});
	const [mode, setMode] = useState("monthly");
	const [year, setYear] = useState(new Date().getFullYear());
	const [isExport, setExport] = useState(false)
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [assetList, setAssetList] = useState([]);
	const { lessee, lessor, currencies, owner } = useSelector((state) => state.leases);
	const [transactionTypes, setTransactionTypes] = useState([]);
	const [currency, setcurrency] = useState("USD");
	const [filter, setFilter] = useState({});
	const [section, setSection] = useState([]);
	const statusLabel = [{ id: "draft", Label: "Draft" }, { id: "active", Label: "Active" }, { id: "closed", Label: "Closed" }, { id: "terminated", Label: "Terminated" }, { id: "on-hold", Label: "On-hold" }]
	const invoiceTypeOptions = [ { label: 'Maintenance Reserve', value: 1 }, { label: 'Rental', value: 2 }, { label: 'Penalty', value: 3 }, { label: 'Debit', value: 4 }, { label: 'Credit', value: 5 }, { label: 'Adhoc', value: 9 }, ];
	const showOnlyOption = [{value:'all',label:'All Section'},{value:'outflows',label:'Outflows Only'},{value:'inflows',label:'Inflows Only'}]
	const currencyOptions = currencies?.length > 0 ? currencies : [ { id: 27, code: 'GBP' }, { id: 3,  code: 'EURO' }, { id: 1,  code: 'USD' }, ];
	const currencyLabel = currency || "USD";
	const currencySymbol = currencyOptions.find( (cur) => String(cur.code) === String(currency) )?.symbol || "$";
	useEffect(() => {
		getCashFlowList('skeletonLoader', mode, year, currency)
		trackActivity('Page Viewed',{ page_title: 'Fleet CashFlow'})
		if (!lessee?.length) {
			dispatch(getLesseeAc({}));
		}

		if (!lessor?.length) {
			dispatch(getOwnerListApi({}));
		}

		if (!currencies?.length) {
			dispatch(getCurrencyAc({}));
		}

		getAssetList();
		getTransactionTypes();
		getSections();
	}, [mode, year, currency])

	const getCashFlowList = (loaderType, selectedMode, selectedYear, selectedCurrency, query = {}) => {
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
		const apiQuery = { ...query };
		if (apiQuery.asset) {
			const selectedAssets = Array.isArray(apiQuery.asset) ? apiQuery.asset : apiQuery.asset.toString().split(',').filter(Boolean);
			apiQuery.asset = selectedAssets.map((key) => {
				const [id, assetType] = key.toString().split('_');
				return assetType ? `${id},${assetType}` : key;
			}).join(',');
		}
		const queryString = new URLSearchParams(apiQuery).toString();
		const hasDateRange = apiQuery?.start_date && apiQuery?.end_date;
		const url = `/cashflows?${hasDateRange ? '' : `year=${selectedYear}&`}mode=${selectedMode}&currency=${selectedCurrency}${queryString ? '&' + queryString : ''}`;
		globalGetService(url)
			.then(response => {
				if (checkApiStatus) {
					setCashFlowListing(response?.data)
					setFilter(query)
					loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
					if(response.data.statusCode === 400){
						enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					}
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
			})
	}

	const getAssetList = () => {
		globalGetService(getAssetListApi({})).then(response => {
			if (checkApiStatus) {
				const formatted = (response?.data?.data || []).map(item => ({
					...item,
					unique_key: `${item.id}_${item.asset_type}`,
				}));
				setAssetList(formatted)
			}
		})
	}

	const getTransactionTypes = (query) => {
		globalGetService(getTransactionTypesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setTransactionTypes(response?.data?.data?.list);
				}
			})
	}

	const getSections = (query) => {
		globalGetService(getCashflowCategoriesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setSection(response?.data?.data?.list);
				}
			})
	}

	const handleCurrencyChange = (newMode) => {
		setcurrency(newMode)
	}

	const handleModeChange = (newMode) => {
		setMode(newMode.toLowerCase())
	}

	const handleYearChange = (direction) => {
		setYear(prev => direction === 'prev' ? prev - 1 : prev + 1)
	}

	const today = new Date()
	const endDate = params?.leaseSlug &&leaseBasicDetails?.end_date ? new Date(leaseBasicDetails.end_date) : null

	const maxAllowedYear = endDate ? endDate.getFullYear() : today.getFullYear();

	const minAllowedYear = params?.leaseSlug &&leaseBasicDetails?.start_date
		? new Date(leaseBasicDetails.start_date).getFullYear()
		: 2000

	const canGoPrev = year > minAllowedYear
	const canGoNext = year < maxAllowedYear

	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: 'Fleet CashFlow', page_type: page_type, })
	}
	
	const cashflowFilterMenu = {
		start_date: { title: 'From Date', inputType: 'date' },
		end_date: { title: 'To Date', inputType: 'date' },
		lessor_ids: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: true },
		lessee_ids: { title: 'Lessee', inputType: 'dropdown', options: lessee, valueKey: 'id', labelKey: 'name', multiple: true },
		// operator_ids: { title: 'Lessee', inputType: 'dropdown', options: lessee, valueKey: 'id', labelKey: 'name', multiple: true },
		asset: { title: 'Asset', inputType: 'dropdown', options: assetList || [], valueKey: 'unique_key', labelKey: 'name', multiple: true,renderOption: (props, option) => ( <Box component="li" {...props} key={option.slug || option.unique_key}> {option.name} </Box>) },
		lease_status: { title: 'Lease Status', inputType: 'dropdown', options: statusLabel, valueKey: 'id', labelKey: 'Label', multiple: true },
		transaction_types: { title: 'Transaction Type', inputType: 'dropdown', options: transactionTypes, valueKey: 'id', labelKey: 'name' },
		show_only: { title: 'Show Only', inputType: 'dropdown', options: showOnlyOption, valueKey: 'value', labelKey: 'label' },
		sections: { title: 'Cashflow Categories', inputType: 'dropdown', options: section, valueKey: 'name', labelKey: 'name' },
		hide_no_activity: { title: 'Hide rows with no activity', inputType: 'checkbox', value: true },
		hide_empty_sections: { title: 'Hide Empty Sections', inputType: 'checkbox', value: true },
	};
	const onApplyFilter = (query) => {
		if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date))) {
			enqueueSnackbar('From Date must be before To Date', { variant: 'error' });
			return false;
		}
		const selectedYear = query.year || year;
		if (query.year) {
			setYear(query.year);
		}
		getCashFlowList("", mode, selectedYear, currency, query);
	};

	const handleExport = (fileType) => {
		let query = { file_type: fileType, year: year, scope: 'fleet', currency:currency }
		setExport(true);
		globalGetService(exportCashFlowApi(query)).then((response) => {
			if (checkApiStatus(response)) {
				enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			setExport(false);
		})
	}
	return (
		<section className="active-asset-section" style={{marginTop: "-5px"}}>
			<DeploymentBannerWithOffset>
				{(bannerHeight) => (
			<Paper className="lease-details-section lease-module-paper " style={{ height: `${window.innerHeight - 70 - bannerHeight}px` }}>
				<div className="lease-details-content" style={{ padding: "0px 10px 0px 0px", margin: "10px 0px 0px 10px" }}>
					<div className="responsive-paper">
						<Grid container spacing={1} style={{placeItems:'flex-start'}}>
							<Grid size={'grow'} item xs={12} sx={{ minWidth: 0 }}>
									<Box display="flex" alignItems="center"  gap={1} flexShrink={0}>
										<div style={{ marginTop: "25px", marginLeft: "-5px" }}>
											<FilterComponent filter={filter} filterMenu={cashflowFilterMenu} getResponseBack={(query) => onApplyFilter(query)}/>
										</div>
									</Box>
							</Grid>
							<Grid size={{ md: 'auto', xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
								<ul className="list-inline lease-details-right-items lease-details-btn">
								   {!(filter?.start_date && filter?.end_date ) ?	
									<li className="lease-mobile-button">
										<Button
											size="small"
											variant="outlined"
											color="primary"
											startIcon={
												<ArrowCircleLeftOutlinedIcon
													sx={{ color: canGoPrev ? '' : 'gray', cursor: canGoPrev ? 'pointer' : 'not-allowed' }}
													onClick={() => { canGoPrev && handleYearChange('prev'); handleItemClicked('Go Previous Year Icon')}}
												/>
											}
											endIcon={
												<ArrowCircleRightOutlinedIcon
													sx={{ color: canGoNext ? '' : 'gray', cursor: canGoNext ? 'pointer' : 'not-allowed' }}
													onClick={() => { canGoNext && handleYearChange('next'); handleItemClicked('Go Next Year Icon')}}
												/>
											}
										>
											{year}
										</Button>
									</li>: null}
									{<li className="list-inline-item lease-mobile-button">
										<PopOverCTA btnText={currencyLabel} onCloseItem={true}>
											<>
												{currencyOptions.map((currency) => (
													<MenuItem key={currency.id} onClick={() => { handleCurrencyChange(currency.code); handleItemClicked(`Clicked on ${currency.code}`); }} >{currency.code}</MenuItem>
												))}
											</>
										</PopOverCTA>
									</li>}
									{cashFlowListing?.mode ? <li className="lease-mobile-button">
										<PopOverCTA btnText={cashFlowListing?.mode}  onCloseItem={true}>
											<>
												<MenuItem onClick={() => { handleModeChange('QUARTERLY'); handleItemClicked('Clicked on Quarterly')}}>QUARTERLY</MenuItem>
												<MenuItem onClick={() => { handleModeChange('YEARLY'); handleItemClicked('Clicked on Yearly')}}>YEARLY</MenuItem>
												<MenuItem onClick={() => { handleModeChange('MONTHLY'); handleItemClicked('Clicked on Monthly')}}>MONTHLY</MenuItem>
											</>
										</PopOverCTA>
									</li> : null}
									{cashFlowListing?.data?.length ? <li className="lease-mobile-button">
										<ExportFileTypeComp handelExport={handleExport} isLoading={isExport}/>
									</li> : null }
								</ul>
							</Grid>
						</Grid>
					</div>
					<Paper className="lease-detail-table lease-module-paper" style={{ marginTop: "0px" }} elevation={0}>
						{skeletonLoader ? (
							<STableLoader count={6} rowCount={13} />
						) : (
							<div style={{ maxHeight: `${window.innerHeight - (isMobile ? 200 : 150) - bannerHeight}px`, padding: "5px", overflow: "auto" }} >
								<CashFlowListing cashFlowListing={cashFlowListing} selectedCurrency={currencyLabel} currencySymbol={currencySymbol} onOpenDetails={(payload) => setCashflowDetailsModal({ open: true, ...payload })} handleItemClicked={handleItemClicked} />
							</div>
						)}
						{isLoading ? <PageLoader /> : null}
					</Paper>
				</div>
			</Paper>
			)}
			</DeploymentBannerWithOffset>
            {cashflowDetailsModal.open && (
                <CashflowDetailsModal open={cashflowDetailsModal.open} onClose={() => setCashflowDetailsModal({ open: false, start_date: null, end_date: null, mode: "monthly" })} start_date={cashflowDetailsModal.start_date} end_date={cashflowDetailsModal.end_date} mode={cashflowDetailsModal.mode} currency={currencyLabel} handleItemClicked={handleItemClicked} />
            )}
		</section>
	)
}

export default RoleBaseAccess(FleetCashflow, { application: 'lease_revamp', feature: 'cashflow', operationType: ['R'] });
